import React from 'react';
import { formatDate } from '../../common/datetime/FormattedDateTime';
import './UserInfo.scss';

interface Props {
  description: string;
  userName: string | undefined;
  time: Date;
  className?: string;
}

const UserInfo = (props: Props) => {
  const { description, userName, time, className = '' } = props;
  return (
    <div className={`user-info ${className}`}>
      <span className='description text-m m-r-4'>{description}</span>
      <span className='m-r-4 text-strong-m'>{userName}</span>
      <span className='text-m'>· {formatDate(time, true)}</span>
    </div>
  );
};
export default UserInfo;
